<template>
  <div>
    <v-form ref="form" v-model="formValido">
      <v-card elevation="5" class="mx-auto rounded-xl">
        <v-card-title class="primary white--text py-3 px-4">
          <v-icon color="white" class="mr-2">mdi-account-plus</v-icon>
          {{ esEdicion ? 'Editar usuario' : 'Nuevo usuario' }}
        </v-card-title>

        <v-card-text class="pa-4">
          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field
                label="Usuario (login) *"
                v-model="usuario.usuario"
                :rules="reglas"
                outlined prepend-inner-icon="mdi-at"
              />
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                label="Nombre completo *"
                v-model="usuario.nombre"
                :rules="reglas"
                outlined prepend-inner-icon="mdi-account"
              />
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                label="Teléfono"
                v-model="usuario.telefono"
                outlined prepend-inner-icon="mdi-phone"
                type="tel"
              />
            </v-col>
            <v-col cols="12" sm="6">
              <v-select
                v-model="usuario.rol"
                :items="roles"
                item-text="label"
                item-value="value"
                label="Rol en el sistema *"
                outlined prepend-inner-icon="mdi-shield-account"
                :rules="[function(v) { return !!v || 'Selecciona un rol' }]"
              >
                <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-icon small :color="item.color" class="mr-1">{{ item.icon }}</v-icon>
                      {{ item.label }}
                    </v-list-item-title>
                    <v-list-item-subtitle>{{ item.desc }}</v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-select>
            </v-col>

            <!-- Contraseña temporal (solo para crear, no editar) -->
            <v-col cols="12" v-if="!esEdicion">
              <v-expand-transition>
                <div>
                  <v-switch
                    v-model="usarPasswordPersonalizada"
                    label="Establecer contraseña personalizada"
                    color="primary"
                    hide-details
                    class="mb-2"
                  />
                  <v-text-field
                    v-if="usarPasswordPersonalizada"
                    v-model="usuario.passwordTemporal"
                    label="Contraseña temporal *"
                    outlined
                    prepend-inner-icon="mdi-lock"
                    :type="mostrarPass ? 'text' : 'password'"
                    :append-icon="mostrarPass ? 'mdi-eye-off' : 'mdi-eye'"
                    @click:append="mostrarPass = !mostrarPass"
                    hint="El usuario deberá cambiarla en su primer ingreso"
                    persistent-hint
                  />
                  <v-alert v-if="!usarPasswordPersonalizada" type="info" text dense class="mt-1">
                    Se usará la contraseña por defecto: <strong>GimHunter123</strong>
                  </v-alert>
                </div>
              </v-expand-transition>
            </v-col>
          </v-row>

          <!-- Badge de permisos del rol seleccionado -->
          <v-alert v-if="rolSeleccionado" :color="rolSeleccionado.color" text dense rounded="lg" class="mt-2">
            <v-icon left small :color="rolSeleccionado.color">{{ rolSeleccionado.icon }}</v-icon>
            <strong>{{ rolSeleccionado.label }}:</strong> {{ rolSeleccionado.desc }}
          </v-alert>
        </v-card-text>

        <v-card-actions class="pa-4">
          <v-btn text @click="$router.push({ name: 'Usuarios' })">
            <v-icon left>mdi-arrow-left</v-icon> Cancelar
          </v-btn>
          <v-spacer />
          <v-btn color="primary" rounded @click="registrar" :disabled="!formValido" elevation="3">
            <v-icon left>mdi-content-save</v-icon>
            {{ esEdicion ? 'Guardar cambios' : 'Registrar usuario' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
export default {
  name: 'FormUsuario',
  props: ['usuario', 'esEdicion'],
  data: function() {
    return {
      formValido: false,
      mostrarPass: false,
      usarPasswordPersonalizada: false,
      reglas: [function(v) { return !!v || 'Este campo es requerido' }],
      roles: [
        {
          value: 'admin',
          label: 'Administrador',
          icon: 'mdi-shield-crown',
          color: 'amber darken-2',
          desc: 'Acceso total: configuración, reportes, usuarios, membresías y estadísticas',
        },
        {
          value: 'entrenador',
          label: 'Entrenador',
          icon: 'mdi-dumbbell',
          color: 'blue darken-1',
          desc: 'Puede matricular clientes, registrar visitas y procesar pagos',
        },
        {
          value: 'recepcionista',
          label: 'Recepcionista',
          icon: 'mdi-desk',
          color: 'teal darken-1',
          desc: 'Registra visitas y pagos, consulta miembros',
        },
      ],
    }
  },
  computed: {
    rolSeleccionado: function() {
      var self = this
      return this.roles.find(function(r) { return r.value === self.usuario.rol }) || null
    },
  },
  mounted: function() {
    if (!this.usuario.rol) this.usuario.rol = 'recepcionista'
    // Fix bug validación: resetear sin disparar errores
    this.$nextTick(function() {
      if (this.$refs.form) this.$refs.form.resetValidation()
    }.bind(this))
  },
  methods: {
    registrar: function() {
      if (!this.$refs.form.validate()) return
      // Incluir contraseña temporal si se configuró
      if (!this.esEdicion && this.usarPasswordPersonalizada && this.usuario.passwordTemporal) {
        this.$emit('registrado', this.usuario)
      } else {
        // Sin contraseña personalizada — el backend usará la por defecto
        var datos = Object.assign({}, this.usuario)
        delete datos.passwordTemporal
        this.$emit('registrado', datos)
      }
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Usuarios/FormUsuario.vue